import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="not-found-page" data-testid="not-found">
      <h1>404</h1>
      <p>Página no encontrada.</p>
      <p>
        <Link to="/">Volver al inicio</Link>
      </p>
    </main>
  );
}
